import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./base-query";

const faqAPI = createApi({
  reducerPath: "faqAPI",
  baseQuery,
  tagTypes: ["faq"],
  endpoints: (builder) => ({
    getAllFaqs: builder.mutation({
      query: () => ({
        url: `faqs`,
        method: "GET",
      }),
      transformResponse: (response) => response,
      providesTags: ["faq"],
    }),

    getFaqById: builder.mutation({
      query: ({ id }) => ({
        url: `faqs/${id}`,
        method: "GET",
      }),
      transformResponse: (response) => response,
    }),

    createFaq: builder.mutation({
      query: ({ body }) => ({
        url: `faqs`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["faq"],
    }),

    updateFaq: builder.mutation({
      query: ({ id, body }) => ({
        url: `faqs/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["faq"],
    }),

    deleteFaq: builder.mutation({
      query: ({ id }) => ({
        url: `faqs/${id}`,
        method: "DELETE",
        body: {},
      }),
      invalidatesTags: ["faq"],
    }),
  }),
});

export const {
  useGetAllFaqsMutation,
  useGetFaqByIdMutation,
  useCreateFaqMutation,
  useUpdateFaqMutation,
  useDeleteFaqMutation,
} = faqAPI;

export default faqAPI;